<script setup lang="ts">
const { id = "sidebar-filter" } = defineProps<{
  id?: string;
}>();
</script>

<template>
  <aside
    :id
    style="width: 400px"
    class="offcanvas-lg offcanvas-end border-start-0 z-3"
    tabindex="-1"
    data-bs-backdrop="false"
    role="region"
    aria-label="Filter"
    aria-labelledby="sidebar-label"
    aria-live="polite"
  >
    <div class="offcanvas-header d-flex">
      <h1 id="sidebar-label" class="d-flex align-items-center gap-2 mb-0">
        <slot name="title" />
      </h1>
      <button
        type="button"
        class="btn-close d-lg-none"
        data-bs-dismiss="offcanvas"
        :data-bs-target="`#${id}`"
        aria-label="Luk filter"
      ></button>
    </div>
    <div class="offcanvas-body flex-column p-3">
      <slot />
    </div>
  </aside>
</template>
